import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import IncentiveDataTable from "./IncentiveDataTable";
import { closeIncentiveModal, fetchIncentive, openIncentiveModal } from "./store/incentiveSlice";
import AddIncentive from "./AddIncentive";

const Incentive = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.incentiveData || {});

  useEffect(() => {
    dispatch(fetchIncentive());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Incentive "
            title="Dashboard"
            subtitle="Incentive"
            name="Import Incentive"
            onAddClick={() => dispatch(openIncentiveModal())}
          />

          <IncentiveDataTable data={data} loading={loading} />

          <AddIncentive
            show={isModalOpen}
            onClose={() => dispatch(closeIncentiveModal())}
          />
        </div>
      </div>
    </div>
  );
};

export default Incentive;
